import React from "react"

import { Link } from "gatsby"
import Modal from "../modal/modal-patient-care"

import "./hero.css"

const HealthcareBanner = () => {
  return (
    <>
      <div
        // Tag="div"
        // {...bgImage}
        // fluid={imageData}
        className="hero-banner hero-healthcare-banner"
        // preserveStackingContext
        style={{ backgroundPosition: "top center", height: "650px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="hero-custom-quickbase">
                <h1 className="page-title font-weight-medium mt-0 mb-4">
                  Gets Away From Spreadsheets and In Front of More Patients
                </h1>
                <p className="mb-0" style={{ paddingBottom: "20px" }}>
                  We build secure, HIPAA-compliant applications and integrations
                  that give you the time and data needed to improve patient
                  care.
                </p>
                <Modal />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HealthcareBanner
